import { render, staticRenderFns } from "./Internal-Property.vue?vue&type=template&id=715b3d00&scoped=true"
import script from "./Internal-Property.vue?vue&type=script&lang=js"
export * from "./Internal-Property.vue?vue&type=script&lang=js"
import style0 from "./Internal-Property.vue?vue&type=style&index=0&id=715b3d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b3d00",
  null
  
)

export default component.exports